// Must match the server enum
export enum TermType {
  None = 0,
  ElectronicDisclosureAndConsent = 1,
  DepositAccountTermsAndConditions = 2,
  // CardholderTermsAndConditions = 4, currently removed
  ClientPrivacyPolicy = 8,
  ClientTermsOfService = 16,
  CovercyTermsOfUse = 32,
  CovercyBusinessDebitCardholderAgreement = 64,
  ThreadAccountTermsAndConditions = 128,
  ThreadBusinessDebitCardholderAgreement = 256
}

// tslint:disable-next-line:no-namespace
export namespace TermType {
  export function toString(type: TermType): string {
    switch (type) {
      case TermType.ElectronicDisclosureAndConsent:
        return 'Electronic Disclosure and Consent';
      case TermType.ThreadAccountTermsAndConditions:
      case TermType.DepositAccountTermsAndConditions:
        return 'Covercy Business Deposit Account Agreement';
      case TermType.ClientPrivacyPolicy:
        return 'Privacy Policy';
      case TermType.ClientTermsOfService:
      case TermType.CovercyTermsOfUse:
        return 'Terms of Service';
      case TermType.CovercyBusinessDebitCardholderAgreement:
      case TermType.ThreadBusinessDebitCardholderAgreement:
        return 'Covercy Business Debit Cardholder Agreement';
      default:
        return null;
    }
  }

  export function getUrl(type: TermType): string {
    switch (type) {
      case TermType.ElectronicDisclosureAndConsent:
        return 'https://www.covercy.com/electronic-disclosure-and-consent';
      case TermType.DepositAccountTermsAndConditions:
        return 'https://www.covercy.com/covercy-gp-business-deposit-account-agreement';
      case TermType.ThreadAccountTermsAndConditions:
        return 'https://www.covercy.com/covercy-gp-business-deposit-account-agreement-thread';
      case TermType.ClientPrivacyPolicy:
        return 'https://www.covercy.com/privacy';
      case TermType.CovercyTermsOfUse:
      case TermType.ClientTermsOfService:
        return 'https://www.covercy.com/terms-and-conditions';
      case TermType.None:
      case TermType.CovercyBusinessDebitCardholderAgreement:
        return 'https://www.covercy.com/cardholder-agreement';
      case TermType.ThreadBusinessDebitCardholderAgreement:
        return 'https://www.covercy.com/cardholder-agreement-thread';
      default:
        return '';
    }
  }
}

export default TermType;
